import { useContext } from 'react';
import { SendTransactionContext } from '@providers/SendTransactionProvider';

const useSendTransactionContext = () => useContext(SendTransactionContext);

export default useSendTransactionContext;
